var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Perspective.less');

var PerspectiveSubscribe = require('front/components/PerspectiveSubscribe/PerspectiveSubscribe');
var PerspectiveArticlesList = require('front/components/PerspectiveArticlesList/PerspectiveArticlesList');
var PerspectiveArchivesList = require('front/components/PerspectiveArchivesList/PerspectiveArchivesList');

module.exports = Section.extend({

    el: '.Perspective',

    events: {
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'PerspectiveArticlesList': {selector: '.PerspectiveArticlesList', viewConstructor: PerspectiveArticlesList},
        'PerspectiveArchivesList': {selector: '.PerspectiveArchivesList', viewConstructor: PerspectiveArchivesList},
        'PerspectiveSubscribe': {selector: '.PerspectiveSubscribe', viewConstructor: PerspectiveSubscribe}
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'scrollToListFromUrl');

        Section.prototype.initialize.call(this, options);
    },

    activate: function () {
        this.scrollToListFromUrl();

        $(window).on('hashchange', this.scrollToListFromUrl);

        return Section.prototype.activate.call(this);
    },

    deactivate: function (params) {
        $(window).off('hashchange', this.scrollToListFromUrl);

        return Section.prototype.deactivate.call(this, params);
    },

    render: function () {
        var result = Section.prototype.render.call(this);

        return result;
    },

    scrollToListFromUrl: function (e) {
        var hash = location.hash.slice(1);
        var $list = this.$('.Perspective-wrapperSection--' + hash);

        if (!hash) return;

        if (!$list.length) {
            app.animateWindowScroll(0);
        } else {
            if (e) {
                app.animateWindowScroll($list.offset().top - 70);
            } else {
                setTimeout(function () {
                    app.animateWindowScroll($list.offset().top - 70);
                }, 300);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Perspective/Perspective.js
// module id = 287
// module chunks = 0